<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-unum">
    <main class="tpl-unum__main">
      <header class="tpl-unum__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-unum__logo" />
      </header>

      <div class="tpl-unum__progress-track">
        <div
          class="tpl-unum__progress-fill"
          :style="{
            width:
              (isGate
                ? 100
                : ((progress.current - 1) / Math.max(progress.total, 1)) * 100) + '%',
          }"
        ></div>
      </div>

      <div v-if="showHero" class="tpl-unum__hero">
        <h1 class="tpl-unum__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-unum__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <slot />
    </main>

    <footer class="tpl-unum__footer">
      <div class="tpl-unum__footer-links">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
      </div>
      <p v-if="quiz.legal_name" class="tpl-unum__footer-legal">
        {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-unum__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
